<p-dialog
  modal="true"
  position="top" [(visible)]="showDialog"
  [closable]="false"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4>
      {{
        profileContact?.ContactId
          ? ('profiles.contact.edit.edit-contact' | translate | titlecase)
          : ('profiles.contact.edit.add-a-contact' | translate | titlecase)
      }}
    </h4>
  </ng-template>
  <div class="dialog-body">
    <form #contactForm="ngForm">
      <div class="mb-54 atlas-form">
        <div class="mb-27 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27"   >
          <div class="mct-flex mct-col mct-flex-1-1-0"  >
            <label>{{ 'profiles.contact.contacted' | translate | titlecase }}</label>
            <p-select
              required
              name="talkedWith"
              [(ngModel)]="profileContact.TalkedWith"
              [options]="relatedProfileItems"
              [style]="{ width: '100%' }"
              [editable]="true"
            ></p-select>
          </div>
          <div class="mct-flex mct-col mct-flex-1-1-0"  >
            <label>{{ 'profiles.contact.subject' | translate | titlecase }}</label>
            <input
              required
              class="full-width"
              name="subject"
              [placeholder]="'profiles.contact.edit.what-was-the-subject' | translate"
              [(ngModel)]="profileContact.Subject"
            />
          </div>
        </div>

        <div class="mb-27 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27"   >
          <div>
            <label>{{ 'profiles.contact.type' | translate | titlecase }}</label>
            <p-select
              required
              appendTo="body"
              name="contactType"
              placeholder="{{ 'profiles.contact.edit.select-a-contact-type' | translate }}"
              [(ngModel)]="profileContact.ContactType"
              [options]="contactTypeItems"
              [style]="{ width: '100%', height: '36px' }"
              showClear
            ></p-select>
          </div>
          <div>
            <label>{{ 'profiles.contact.edit.who-contacted' | translate }}</label>
            <p-select
              required
              appendTo="body"
              name="whoContacted"
              placeholder="{{ 'profiles.contact.edit.select' | translate }}"
              [(ngModel)]="profileContact.Contactee"
              [options]="contacteeUserItems"
              [style]="{ width: '100%', height: '36px' }"
              showClear
            ></p-select>
          </div>
          <div>
            <label>{{ 'profiles.contact.contact-date' | translate | ucfirst }}</label>
            <wl-date-selector
              ngDefaultControl
              [required]="true"
              appendTo="body"
              name="contactDate"
              [(ngModel)]="profileContact.ContactDate"
            ></wl-date-selector>
          </div>
        </div>

        <div>
          <label>{{ 'profiles.contact.description' | translate | titlecase }}</label>
          <textarea
            class="full-width"
            name="description"
            [(ngModel)]="profileContact.Descr"
            [placeholder]="'profiles.contact.edit.enter-a-description' | translate"
          ></textarea>
        </div>
      </div>

      <div>
        <div class="mct-flex mct-row">
          <p-checkbox binary="true" name="createTask" labelStyleClass="light-text" [(ngModel)]="createTask" inputId="createTask">
          </p-checkbox>
          <label for="createTask" class="light-text">
            {{ 'profiles.contact.edit.create-a-task-from-this-contact' | translate | titlecase }}
          </label>
        </div>
        <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27"   >
          <div>
            <label>{{ 'tasks.edit.task-type' | translate | ucfirst }}</label>
            <p-select
              name="taskType"
              required
              appendTo="body"
              placeholder="{{ 'tasks.edit.select-a-task-type' | translate }}"
              [(ngModel)]="task.TaskType"
              [options]="taskTypeItems"
              [style]="{ width: '100%', height: '36px' }"
              showClear
              [disabled]="!createTask"
            ></p-select>
          </div>
          <div>
            <label for="assignedTo">{{ 'tasks.edit.assigned-to' | translate | ucfirst }}</label>
            <p-select
              required
              id="assignedTo"
              name="assignedTo"
              appendTo="body"
              placeholder="{{ 'tasks.edit.assign-this-task' | translate }}"
              [(ngModel)]="task.UserNum"
              [options]="assignedToUserItems"
              [style]="{ width: '100%', height: '36px' }"
              showClear
              [disabled]="!createTask"
            ></p-select>
          </div>
          <div>
            <label>{{ 'tasks.edit.due-date' | translate | ucfirst }}</label>
            <wl-date-selector
              ngDefaultControl
              [required]="true"
              name="dueDate"
              [(ngModel)]="task.DateDue"
              appendTo="body"
              [disabled]="!createTask"
            ></wl-date-selector>
          </div>
        </div>
        <div>
          <span class="assign-to-note light-text">{{ 'profiles.contact.edit.assignee-will-receive-email-note' | translate }}</span>
        </div>
      </div>
    </form>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="close()">{{ 'common.cancel' | translate | uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!contactForm.valid || isSaving" (click)="submit()">
      <span *ngIf="!isSaving">
        {{ 'profiles.contact.edit.save-this-contact' | translate | uppercase }}
      </span>
      <wl-busy *ngIf="isSaving"></wl-busy>
    </button>
  </ng-template>
</p-dialog>
